export enum AdGroupType {
    Category = 1,
    Family = 2,
    Industry = 3
};